import { render, staticRenderFns } from "./UploadLogo.vue?vue&type=template&id=5ebf9a42&scoped=true"
import script from "./UploadLogo.vue?vue&type=script&lang=js"
export * from "./UploadLogo.vue?vue&type=script&lang=js"
import style0 from "./UploadLogo.vue?vue&type=style&index=0&id=5ebf9a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf9a42",
  null
  
)

export default component.exports